import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';
import { mediaQueries } from '../../styles/media-queries';
import { Flexbox } from '../Flexbox';
import { pxToRem } from '../../styles/utils';
import GlImage from '../Image';

export const Wrapper = styled(Flexbox)`
  flex-direction: column-reverse;
  padding: 0 ${({ theme }) => theme.spacing.s};
  margin: 0 auto;

  ${mediaQueries.tablet} {
    max-width: ${pxToRem(880)};
    flex-wrap: nowrap;
    flex-direction: row;
  }
`;

export const TextWrapper = styled(Box)<{ textAlign: string }>`
  width: 100%;
  text-align: ${({ textAlign }) => textAlign};

  ${mediaQueries.tablet} {
    width: auto;
    margin: auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

export const ListItem = styled('li')`
  padding-left: 10px;
  p {
    font-size: ${({ theme }) => theme.fontSize.p_0};
    font-weight: ${({ theme }) => theme.fontWeight.p};
    margin-bottom: 15px;
  }

  ${mediaQueries.tablet} {
    p {
      font-size: ${({ theme }) => theme.fontSize.h3_tablet};
      font-weight: ${({ theme }) => theme.fontSize.h3_tablet};
      margin-bottom: 25px;
    }
  }
`;

export const StyledImage = styled(GlImage)`
  height: unset !important;
  max-width: ${pxToRem(120)};
  ${mediaQueries[0]} {
    margin-top: ${pxToRem(25)};
    margin-right: ${pxToRem(105)};
  }
  ${mediaQueries.min} {
    margin-top: ${pxToRem(25)};
    margin-right: ${pxToRem(165)};
  }
  @media screen and (min-width: 425px) {
    margin-top: ${pxToRem(25)};
    margin-right: ${pxToRem(220)};
  }
  ${mediaQueries.tablet} {
    margin-top: ${pxToRem(35)};
    margin-right: ${pxToRem(475)};
  }
  ${mediaQueries.desktop} {
    margin-top: ${pxToRem(35)};
    margin-right: ${pxToRem(690)};
  }
`;

export const InfoBlockContainer = styled('div')<{ bgColor?: string }>`
  background-color: ${({ bgColor, theme }) =>
    bgColor ? `#${bgColor}` : theme.color.infoBg};
  width: 100%;
  height: 100%;
  padding: 0;
  border-radius: ${({ theme }) => theme.borderRadius.blockquote_0};
  ${mediaQueries.tablet} {
    border-radius: ${({ theme }) => theme.borderRadius.blockquote_tablet};
  }
  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.block_desktop};
  }
`;
